export function GlobalLoader() {
  return (
    <div className="global-loader h-[4px] w-full relative overflow-hidden block m-0 z-30 before:absolute before:w-[50px] before:h-[5px] before:left-[50px] animate-[global-loader_1.5s_linear_infinite]"></div>
  );
}
